import { useMutation, useQueryClient } from 'react-query';
import ProfileApi from '../ProfileApi';
import IDroneAvailability from '../IDroneAvailability';
import { droneAvailabilityQueryKey } from './useDroneAvailabilityQuery';

export function useUpdateDroneAvailabilityMutation() {
    const queryClient = useQueryClient();

    return useMutation<void, unknown, boolean>(
        (hasDrone: boolean) => ProfileApi.updateDroneAvailability(hasDrone),
        {
            onSuccess: (_result: void, hasDrone: boolean) => {
                queryClient.setQueryData<IDroneAvailability>(
                    droneAvailabilityQueryKey,
                    (current: IDroneAvailability) =>
                        current ? { ...current, hasDrone: hasDrone } : current
                );
            }
        }
    );
}
